// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marquee-wrapper {
  overflow: hidden;
  position: relative;
  -webkit-mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
  mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);
}

.marquee-track {
  display: flex;
  width: max-content;
  animation: marquee 22s linear infinite;
}

@keyframes marquee {
  from { transform: translateX(0); }
  to { transform: translateX(-50%); }
}

@keyframes gpShimmer  { from{background-position:-200% center;} to{background-position:200% center;} }

.shimmer-text {
    background: linear-gradient(90deg, #f97316 0%, #fbbf24 30%, #f97316 60%, #ea580c 100%);
    background-size: 200% auto;
    -webkit-background-clip: text; background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: gpShimmer 3s linear infinite;
  }`, "",{"version":3,"sources":["webpack://./src/helpers/secondarycss.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,4FAA4F;EAC5F,oFAAoF;AACtF;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,OAAO,wBAAwB,EAAE;EACjC,KAAK,2BAA2B,EAAE;AACpC;;AAEA,wBAAwB,KAAK,gCAAgC,CAAC,EAAE,GAAG,+BAA+B,CAAC,EAAE;;AAErG;IACI,sFAAsF;IACtF,0BAA0B;IAC1B,6BAA6B,EAAE,qBAAqB;IACpD,oCAAoC;IACpC,uCAAuC;EACzC","sourcesContent":[".marquee-wrapper {\n  overflow: hidden;\n  position: relative;\n  -webkit-mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);\n  mask-image: linear-gradient(to right, transparent, black 8%, black 92%, transparent);\n}\n\n.marquee-track {\n  display: flex;\n  width: max-content;\n  animation: marquee 22s linear infinite;\n}\n\n@keyframes marquee {\n  from { transform: translateX(0); }\n  to { transform: translateX(-50%); }\n}\n\n@keyframes gpShimmer  { from{background-position:-200% center;} to{background-position:200% center;} }\n\n.shimmer-text {\n    background: linear-gradient(90deg, #f97316 0%, #fbbf24 30%, #f97316 60%, #ea580c 100%);\n    background-size: 200% auto;\n    -webkit-background-clip: text; background-clip: text;\n    -webkit-text-fill-color: transparent;\n    animation: gpShimmer 3s linear infinite;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
